import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import {
	ProcessFilesRequest,
	GetSiteStringRequest
} from '../requests/UploadsRequests.js';

export const ProcessFile = (fileLocation) => async (dispatch) => {
	await ProcessFilesRequest(fileLocation).then(response => {
		dispatch(enqueueSnackbar({ message: 'Files uploaded with success!', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const Upload = (file) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ProcessFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSiteString = () => async (dispatch) => {
	await GetSiteStringRequest().then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
